import { render, staticRenderFns } from "./SectionProcess.vue?vue&type=template&id=65044a84&scoped=true&"
var script = {}
import style0 from "./SectionProcess.vue?vue&type=style&index=0&id=65044a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65044a84",
  null
  
)

export default component.exports